module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZmZlODAwIiBkPSJNMCAwaDY0MHY0ODBIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiMwMDE0OGUiIGQ9Ik0wIDI0MGg2NDB2MjQwSDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjZGEwMDEwIiBkPSJNMCAzNjBoNjQwdjEyMEgweiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/co.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/co.svg
// module chunks = 0